export interface AppConfig {
  appName: string;
  appUrl: string;
  apiUrl: string;
}

const isProduction = import.meta.env.PROD;

export const config: AppConfig = {
  appName: import.meta.env.VITE_APP_NAME || 'Agentor',
  appUrl: import.meta.env.VITE_APP_URL || 'http://localhost:3000',
  apiUrl: isProduction ? '' : (import.meta.env.VITE_API_URL || 'http://localhost:3001'),
};
